// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HBSy6","newExpiryDate":"styles_newExpiryDate__rHur5","footer":"styles_footer__2Z86Y"};